const coPropList = (state) => state.coPropList;
const meterList = (state) => state.meterList;
const addressList = (state) => state.addressList;
const lotList = (state) => state.lotList;
const lotPDF = (state) => state.lotPDFData
const previousUnitDetails = (state) => state.previousUnitData
const landingPageDetails = (state) => state.landingPageCount
const completedSessionHomeDetails = (state) => state.completedSessionHome
export default {
  coPropList,
  meterList,
  lotList,
  addressList,
  lotPDF,
  previousUnitDetails,
  landingPageDetails,
  completedSessionHomeDetails
}


// WEBPACK FOOTER //
// ./src/store/modules/coprops/getters.js